package pwgs.ui.scenes.diagnosticserrorgroupsscene

import visage.core.AComponent
import visage.core.Components
import visage.core.AScene
import visage.core.Navigation
import visage.ds.components.Card
import visage.ds.components.Table
import visage.ds.components.page.Page
import kotlin.js.Date

class MDiagnosticsErrorGroupsScene(props: DiagnosticsErrorGroupsSceneProps) : AScene<DiagnosticsErrorGroupsSceneProps, DiagnosticsErrorGroupsSceneModel, DiagnosticsErrorGroupsSceneState, DiagnosticsErrorGroupsControllerFe>(props) {

    var title: String = "Untitled"

    override fun createController() : DiagnosticsErrorGroupsControllerFe {
        return DiagnosticsErrorGroupsControllerFe(props, this)
    }

    override fun initState() : DiagnosticsErrorGroupsSceneState {
        return DiagnosticsErrorGroupsSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        val model = this@MDiagnosticsErrorGroupsScene.model
        Page {
            isLoading = model.isLoading
            head(this@MDiagnosticsErrorGroupsScene.title)
            body {
                Card {
                    header("Issue groups")
                    body {
                        Table {
                            columns {
                                fixedColumn("Message")
                                fixedColumn("Count")
                                fixedColumn("First seen at")
                                fixedColumn("Last seen at")
                            }
                            body {
                                model.items.forEach {
                                    row {
                                        cell(it.content)
                                        cell("${it.issueCount}")
                                        cell(Date(it.firstSeenAt).toLocaleString())
                                        cell(Date(it.lastSeenAt).toLocaleString())

                                        onClick = { x ->
                                            Navigation.pushLocation("/app/project/${this@MDiagnosticsErrorGroupsScene.props.projectId}/diagnostics/${it.id}/issues.vsg")
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

class DiagnosticsErrorGroupsSceneState {

}

fun Components.DiagnosticsErrorGroupsScene(title: String, props: DiagnosticsErrorGroupsSceneProps) = this.registerComponent(MDiagnosticsErrorGroupsScene(props)) {
    this.title = title
}
